module.exports = __webpack_public_path__ + "static/border_white-b61978bc513ec23db8a3cc3603ce85fb.png";